import { useTranslation } from 'react-i18next'

import Icon from '../ui/Icon'
import { Button } from '../buttons/Button'
import { Buttons } from '../buttons/Buttons'

import { ThemeType } from '../../types/contexts/AppContext'

type ThemeToggleProps = {
  theme: ThemeType
  onThemeChange: (theme: ThemeType) => void
  disabled?: boolean
  labelClassName?: string
  optionLabelClassName?: string
}

export const ThemeToggle = ({
  theme,
  onThemeChange,
  disabled = false,
  labelClassName = '',
  optionLabelClassName = '',
}: ThemeToggleProps) => {
  const { t } = useTranslation('nav')
  const optionLabel = ['foot-option-label', optionLabelClassName]
    .filter(Boolean)
    .join(' ')

  return (
    <>
      <span className={`foot-label foot-theme-label ${labelClassName}`.trim()}>
        {t('foot-bar.theme')}
      </span>
      <Buttons className="foot-toggle theme-toggle">
        <Button
          variant="ghost"
          className={`foot-option rounded-pill ${
            theme === ThemeType.LIGHT ? 'on' : ''
          }`}
          icon={<Icon name="sun" size={18} />}
          label={t('foot-bar.light-theme')}
          labelClassName={optionLabel}
          onClick={() => onThemeChange(ThemeType.LIGHT)}
          disabled={disabled}
          aria-label={t('foot-bar.light-theme')}
        />
        <Button
          variant="ghost"
          className={`foot-option rounded-pill ${
            theme === ThemeType.DARK ? 'on' : ''
          }`}
          icon={<Icon name="moon" size={18} />}
          label={t('foot-bar.dark-theme')}
          labelClassName={optionLabel}
          onClick={() => onThemeChange(ThemeType.DARK)}
          disabled={disabled}
          aria-label={t('foot-bar.dark-theme')}
        />
      </Buttons>
    </>
  )
}
